import React, { useState, useEffect, useRef } from 'react';
import {
  TextField, Button, Grid, Typography, Paper, Accordion, AccordionSummary, AccordionDetails,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Card, CardContent, Divider, Box, TablePagination,
  Alert, Modal, Tab, Autocomplete, Fab,
  LinearProgress, Checkbox, Switch, FormControlLabel
} from '@mui/material';
import { Download, Trash2, Send, CloudDownload, CloudUpload } from 'lucide-react';
import { styled } from '@mui/material/styles';

import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es, fr } from 'date-fns/locale';
import { CreditorService } from '../../services/creditorService';
import { LobService } from '../../services/lobService';
import { layoutService } from '../../services/layoutService';
import { formatToCLP } from '../../services/monedaService';
import { format } from 'date-fns';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ContractPDF from '../ContractPDF';
import { Editor } from '@tinymce/tinymce-react';
import html2pdf from 'html2pdf.js';
import { FirmaService } from '../../services/firmaService';
import { LoadingButton } from '@mui/lab';

import { useSelector, useDispatch } from 'react-redux';
import { setContractFull, setTab } from '../../Redux/TabDucks';
import Swal from 'sweetalert2';
import { setCargaDatos } from '../../Redux/GeneralDuck';
import { jsPDF } from "jspdf";
import { Layout, SendIcon } from 'lucide-react';
import { InterviewService } from '../../services/interviewService';
import moment from "moment"; // Importar moment.js
import { KeyboardArrowUp } from '@mui/icons-material';
import { ValidarRut, ValidarEmail } from '../../Utilities/ValidarRut';
import { DoDisturb } from '@mui/icons-material';

const style = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'auto', bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4, };

const GeneradorForm = ({ key, reiniciar }) => {
  const dispatch = useDispatch();
  const contractData = useSelector((store) => store.tab.contractFull);
  const _TAB = useSelector((store) => store.tab);
  const _GENERAL = useSelector((store) => store.general);

  const [finiquitado, setFiniquitado] = useState(false);
  const [cancelado, setCancelado] = useState(false);
  const [bloquearAcciones, setBloquearAcciones] = useState(false);
  const [emailSign, setEmailSign] = useState("");
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Bloquea F5
      if (event.key === "F5") {
        event.preventDefault();
        alert("El uso de F5 está bloqueado 🚫");
      }
      if ((event.ctrlKey || event.metaKey) && event.key === "r") {
        event.preventDefault();
        alert("Ctrl+R bloqueado 🚫");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // muestra un diálogo nativo de confirmación
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);


  useEffect(() => {
    /*if (!_TAB.Cuotas?.find(x => x.isApproved == true))
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Las cuotas aun no están aprobadas...",
        showConfirmButton: true,
        timer: 2000,
      });*/

    //if(isApproved)
    if (_TAB.contractFull?.cancel == true) {
      setCancelado(true)
      setBloquearAcciones(true)
    }
    if (_TAB.contractFull?.finiquitado == true) {
      setFiniquitado(true)
      setValueTab("2")
      setBloquearAcciones(true)
    }

    if (_TAB?.contractFull?.pagador?.email && _TAB?.contractFull?.pagador?.email != "")
      setEmailSign(_TAB?.contractFull?.pagador?.email?.trim() || "")
  }, [_TAB])

  const editorRefs = useRef([]);

  const [formData, setFormData] = useState({
    identifier: '',
    firstName: '',
    lastName: '',
    email: '',
    numContrato: '',
    contractId: '',
    fechaContrato: null,
    observaciones: '',
  });

  const [creditors, setCreditors] = useState([]);
  const [linesOfBusiness, setLinesOfBusiness] = useState([]);
  const [installments, setInstallments] = useState({});
  const [cuotasData, setCuotasData] = useState([]);
  const [acreedorData, setAcreedores] = useState([]);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showChooseSignature, setShowChooseSignature] = useState({ show: false });
  //const [documents, setDocuments] = useState([]);
  const [sendedList, setSendedList] = useState([]);
  const [loadingList, setLoadingList] = useState([]);
  const [page, setPage] = useState(0); // Página actual.
  const [rowsPerPage, setRowsPerPage] = useState(5); // Filas por página.
  const [openM, setOpenM] = useState(false);
  const [listCrono, setListCrono] = useState([]);
  const [valueTab, setValueTab] = useState("1");
  const [templateContratos, setTemplateContratos] = useState([]);
  const [tempContrat, setTempContrat] = useState([]);

  const [visible, setVisible] = useState(false);

  //cuotas
  const [pagecuota, setPages] = useState({}); // Página actual.
  const [rowsPerPagecuota, setRowsPerPages] = useState({}); // Filas por página.

  const columns = [
    {
      id: 'N° Cuota',
      label: 'N° Cuota',
      minWidth: 170,
      align: 'right',
    },
    {
      id: 'Monto',
      label: 'Monto',
      minWidth: 170,
      align: 'right',
    },
    {
      id: 'Fecha Pago',
      label: 'Fecha Pago',
      minWidth: 170,
      align: 'right',
    }

  ]

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {

        // Verificar que los parámetros son correctos
        const contrato = await LobService.getCustomerContract(contractData.rut, contractData.numContratos);

        var listContratos = await LobService.getTemplateContratos(contrato.contract.contract_Line[0].idBusiness, 0/* tipo contrato */)
        setTemplateContratos(listContratos.map(item => ({ ...item, label: item.name })));

        setFormData({
          identifier: contrato.customer.identifier || '',
          firstName: contrato.customer.firstName || '',
          lastName: contrato.customer.lastName || '',
          email: contrato.customer.email || '',
          numContrato: contrato.contract.numContrato || '',
          contractId: contrato.contractId || '',
          fechaContrato: contrato.contract.fechaContrato ? new Date(contrato.contract.fechaContrato) : null,
          observaciones: contrato.customer.observaciones || '',
        });

        var lb = contrato.contract.contract_Line.map((line, index) => ({ ...line, html: line.html ?? "Seleccione Contrato" }))
        var lc = contrato.contract.contract_Line.map((line, index) => ({ ...line, html: line.html ?? "Seleccione Contrato" }))
        setTempContrat(lc || [])
        setLinesOfBusiness(lb || []);
        setSendedList(new Array(linesOfBusiness.length).fill(false))
        setCuotasData(contrato.contract.cuotas || []);
        setAcreedores(contrato.acreedores || []);


      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };
    fetchInitialData();
    dispatch(setCargaDatos())
  }, []);

  const onChangeSelectContract = async (event, value, IndexLinesOfBusiness) => {

    if (value == null) value = { html: "", id: 0 }

    const updatedLinesOfBusiness = [...linesOfBusiness];
    updatedLinesOfBusiness[IndexLinesOfBusiness].html = value.html;
    updatedLinesOfBusiness[IndexLinesOfBusiness].layoutId = value.id;
    setLinesOfBusiness(updatedLinesOfBusiness);

  }

  useEffect(() => {
    const fetchCuotas = async () => {

      try {
        // Llamada al servicio para obtener los datos
        const data = await LobService.getCuotasContrato(formData.identifier, formData.contractId);
        setCuotasData(data);
      } catch (error) {
        setError('Error al obtener las cuotas del contrato.');
      } finally {
        setLoading(false);
      }
    };

    fetchCuotas();
  }, []);

  const ShowConsentimiento = async (idService) => {
    try {
      // Llamada al servicio para obtener los datos
      const data = await layoutService.getLayoutByServiceId(idService);

      const tempElement = document.createElement('div');
      var html = data.layoutContent

      html = html.replace(/@nombre_defendido/g, _TAB.customerFormatted?.firstName || "@nombre_defendido")
      html = html.replace(/@rut_defendido/g, _TAB.customerFormatted?.identifier || "@rut_defendido")
      html = html.replace(/@empresa/g, _TAB.contractFull?.negocios[0]?.name || "@empresa")

      var aux = opt
      aux.filename = "Consentimiento.pdf"
      tempElement.innerHTML = html
      await html2pdf().set(aux).from(tempElement).save();

    } catch (error) {
      console.log(error);
      setError('Error al obtener las cuotas del contrato.');
    } finally {
      setLoading(false);
    }
  }

  const handleClientDataChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const CheckhandleSign = async (contractLineId, index, type) => {

    setLoadingList((prev) => {
      const newLoadingList = [...prev];
      newLoadingList[index] = true;
      return newLoadingList;
    });

    Swal.fire({
      title: 'Revisando firma...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })

    var response = await FirmaService.GetESign(contractLineId, type);

    Swal.close();

    if (response.error) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: response.message,
        showConfirmButton: true,
        timer: 5000,
      });
    } else if (response.cancelado) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: response.message,
        showConfirmButton: true,
        timer: 4000,
      });
    } else if (response.firmado) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: response.message,
        showConfirmButton: true,
        timer: 4000,
      });
    } else {
      Swal.fire({
        title: response.message,
        icon: "info",
        confirmButtonText: "Esperar Firma",
        timer: 4000,
        html: `<button id="custom-btn" class="swal2-confirm swal2-styled" style="background: #ff9900;">Anular Contrato Electronico</button>`,
        didOpen: () => {
          document.getElementById("custom-btn").addEventListener("click", () => {
            Swal.close();
            Swal.fire({
              title: "¿Anular Contrato Electronico?",
              icon: "warning",
              confirmButtonText: "Esperar Firma",
              html: `<button id="custom-btn2" class="swal2-confirm swal2-styled" style="background:rgb(255, 53, 26);">Confirmar Anulacion</button>`,
              didOpen: async () => {
                document.getElementById("custom-btn2").addEventListener("click", () => {
                  CheckCancelSign(contractLineId, index, type)
                });
              },
            })
          })
        },
      })
    }

    const updatedLinesOfBusiness = linesOfBusiness.map(line => {
      if (line.id === contractLineId) {
        return {
          ...line,
          signed: response.firmado,
          canceled: response.cancelado
        };
      }
      return line;
    });
    setLinesOfBusiness(updatedLinesOfBusiness);

    setLoadingList((prev) => {
      const newLoadingList = [...prev];
      newLoadingList[index] = false;
      return newLoadingList;
    });

    setTimeout(() => {
      //navigate(0)
      //window.reload();
      //navigate(window.location.pathname, { replace: true });
      reiniciar()
    }, 2000);

  }

  const CheckCancelSign = async (contractLineId, index, type) => {
    setLoadingList((prev) => {
      const newLoadingList = [...prev];
      newLoadingList[index] = true;
      return newLoadingList;
    });

    Swal.fire({
      title: 'Cancelando firma...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })

    var response = await FirmaService.CancelESign(contractLineId, type);
    Swal.close();

    Swal.fire({
      title: response.message,
      icon: response.cancelado ? "info" : "warning",
      showConfirmButton: true,
      timer: 4000,
    })

    const updatedLinesOfBusiness = linesOfBusiness.map(line => {
      if (line.id === contractLineId) {
        return {
          ...line,
          signed: response.firmado,
          canceled: response.cancelado
        };
      }
      return line;
    });
    setLinesOfBusiness(updatedLinesOfBusiness);

    setLoadingList((prev) => {
      const newLoadingList = [...prev];
      newLoadingList[index] = false;
      return newLoadingList;
    });

    setTimeout(() => {
      //navigate(0)
      reiniciar()
    }, 2000);
  }

  const UploadSign = async (contractLineId, index, files) => {
    Swal.fire({
      title: 'Subiendo Archivo...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })

    var response = await FirmaService.UploadSign(contractLineId, files);
    Swal.close();

    Swal.fire({
      title: response.message,
      icon: response.firmado ? "success" : "warning",
      showConfirmButton: true,
      timer: 4000,
    })

    const updatedLinesOfBusiness = linesOfBusiness.map(line => {
      if (line.id === contractLineId) {
        return {
          ...line,
          signedManual: response.firmado,
          canceled: response.cancelado
        };
      }
      return line;
    });

    setLinesOfBusiness(updatedLinesOfBusiness);

    setLoadingList((prev) => {
      const newLoadingList = [...prev];
      newLoadingList[index] = false;
      return newLoadingList;
    });


    setTimeout(() => {
      //navigate(0)
      reiniciar()
    }, 2000);

  }

  const handleSign = async (index, type, line) => {
    if (emailSign == null || emailSign == "" || emailSign == undefined || !ValidarEmail(emailSign)) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Falta email del pagador",
        confirmButtonText: "Entendido"
      })
      return
    }
    if (linesOfBusiness[index].layoutId == null || linesOfBusiness[index].layoutId == 0 || linesOfBusiness[index].html.includes("Seleccione Contrato")) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "No ha seleccionado contrato",
        confirmButtonText: "Entendido"
      })
      return
    }
    else if (linesOfBusiness[index].html != tempContrat[index].html) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Ha modificado el contrato, Confirme la revision antes de enviar a firmar",
        confirmButtonText: "Entendido"
      })
      return
    }

    var sfire = Swal.fire({
      title: "Preparando Documento...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })
    var enviado = false;
    if (type == "MANUAL")
      enviado = await FirmaService.sendManualSign(linesOfBusiness[index].id, type, emailSign)
    else
      enviado = await FirmaService.sendESign(linesOfBusiness[index].id, type, emailSign, checked)

    if (enviado) {
      setSendedList(prevSendedList => {
        const newSendedList = [...prevSendedList]
        newSendedList[index] = true
        return newSendedList
      })
      setLoadingList((prev) => {
        const newLoadingList = [...prev]
        newLoadingList[index] = false
        return newLoadingList
      })
      sfire.close()
      var waitSwal = null
      if (type != "MANUAL")
        waitSwal = Swal.fire({
          title: 'Contrato enviado, espere mientras refresca...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        })
      setTimeout(() => {
        //navigate(0)
        if (waitSwal != null)
          waitSwal.close();
        reiniciar()
      }, 2000)
    } else {
      sfire.close();
    }
  }

  const handleEditorBlur = (index) => {
    const editor = editorRefs.current[index];
    if (editor) {
      const updatedLinesOfBusiness = [...linesOfBusiness];
      updatedLinesOfBusiness[index].html = editor.getContent()
      setLinesOfBusiness(updatedLinesOfBusiness);
    }
  };

  const ReplaceAllTags = (texto, index) => {
    var _f = extraerFecha(formData.fechaContrato) || ""

    var cuotas = linesOfBusiness[index].cuotas.length > 0 ? generarTablaCuotas(linesOfBusiness[index].cuotas[0]?.pagoCuotas) : ''
    var acreedores = generarTablaAcreedores(index)
    let totalAmount = `$ ${linesOfBusiness[index].contractServices.reduce((total, service) => total + (service.amount || 0), 0)}` || ""

    texto = texto.replace(/@sucursal/g, _TAB.Sucursales?.find(x => x.id == _TAB.customerFormatted.sucursal)?.name || "@sucursal")
    texto = texto.replace(/@codigo_contrato/g, linesOfBusiness[index].codCtto?.trim() || "@codigo_contrato")
    texto = texto.replace(/@tipo_fuente/g, linesOfBusiness[index].codCtto?.trim() || "@tipo_fuente")
    texto = texto.replace(/@dia_entrevista/g, _f.dia?.trim() || "@dia_entrevista")
    texto = texto.replace(/@mes_entrevista/g, _f.mesTexto?.trim() || "@mes_entrevista")
    texto = texto.replace(/@anio_entrevista/g, _f.año?.trim() || "@anio_entrevista")
    texto = texto.replace(/@nombre_pagador/g, `${_TAB.contractFull.pagador?.firstName?.trim() || ""} ${_TAB.contractFull.pagador?.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
    texto = texto.replace(/@rut_pagador/g, _TAB.contractFull.pagador?.identifier?.trim() || "@rut_pagador")
    texto = texto.replace(/@estado_civil_pagador/g, _GENERAL.estadoCivil?.find(x => x.id == _TAB.contractFull.pagador?.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
    texto = texto.replace(/@ocupacion_pagador/g, _TAB.contractFull.pagador?.ocupacion?.trim() || "@ocupacion_pagador")
    texto = texto.replace(/@ocupacion_pagaddor/g, _TAB.contractFull.pagador?.ocupacion?.trim() || "@ocupacion_pagaddor")
    texto = texto.replace(/@direccion_pagador/g, _TAB.contractFull.pagador?.address?.trim() || "@direccion_pagador")
    texto = texto.replace(/@comuna_pagador/g, _GENERAL.comunas?.find(x => x.id == _TAB.contractFull.pagador?.idDistrito)?.description?.trim() || "@comuna_pagador")
    texto = texto.replace(/@comuna_pagado/g, _GENERAL.comunas?.find(x => x.id == _TAB.contractFull.pagador?.idDistrito)?.description?.trim() || "@comuna_pagado")
    texto = texto.replace(/@region_pagador/g, _GENERAL.regiones?.find(x => x.id == _TAB.contractFull.pagador?.idRegion)?.description?.trim() || "@region_pagador")
    texto = texto.replace(/@telefono_pagador/g, _TAB.contractFull.pagador?.telephone?.trim() || "@telefono_pagador")
    texto = texto.replace(/@celular_pagador/g, _TAB.contractFull.pagador?.telephone?.trim() || "@celular_pagador")
    texto = texto.replace(/@email_pagador/g, _TAB.contractFull.pagador?.email?.trim() || "@email_pagador")
    texto = texto.replace(/@firmas/g, "")//"@firmas"
    texto = texto.replace(/@nacionalidad_pagador/g, _GENERAL.paises?.find(x => x.id == _TAB.contractFull.pagador?.idCountry)?.description?.trim() || "@nacionalidad_pagador")
    texto = texto.replace(/@origen/g, _TAB.interview?.origen?.toUpperCase().trim() || "REMOTO")
    texto = texto.replace(/@porcentajes/g, "@porcentajes")
    texto = texto.replace(/@cuotas/g, cuotas?.trim() || "@cuotas")
    texto = texto.replace(/@acreedores/g, acreedores || "@acreedores")
    texto = texto.replace(/@defensavictimas/g, "@defensavictimas")
    texto = texto.replace(/@fecha_texto_fin/g, "@fecha_texto_fin")
    texto = texto.replace(/@fecha_act_texto/g, "@fecha_act_texto")
    texto = texto.replace(/@h_acreedores/g, "@h_acreedores")
    texto = texto.replace(/@defensafamilia/g, "@defensafamilia")
    texto = texto.replace(/@nombre_empresa_pyme/g, "@nombre_empresa_pyme")
    texto = texto.replace(/@defensafamilias/g, "@defensafamilias")
    texto = texto.replace(/@servicios/g, "@servicios")
    texto = texto.replace(/@total_ccontrato/g, totalAmount.trim() || "@total_ccontrato")
    texto = texto.replace(/@toral_contrato/g, totalAmount.trim() || "@toral_contrato")
    texto = texto.replace(/@total_contrato/g, totalAmount.trim() || "@total_contrato")
    texto = texto.replace(/@fi/g, "@fi")

    return texto;
  }

  const convertDocumentToPdfBase64 = async (index) => {
    const htmlContent = ReplaceAllTags(linesOfBusiness[index].html, index)
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlContent
    document.body.appendChild(tempElement)
    try {
      const pdfBase64 = await html2pdf().set(opt).from(tempElement).outputPdf('datauristring');
      document.body.removeChild(tempElement);
      return pdfBase64
    } catch (error) {
      document.body.removeChild(tempElement)
      console.error('Error al convertir a PDF:', error)
    }
  }

  const ShowPDF = async (index) => {

    const parser = new DOMParser()
    var _old = parser.parseFromString(linesOfBusiness[index].html, "text/html").body.innerHTML
    var _new = "aji"// parser.parseFromString(documents[index], "text/html").body.innerHTML

    if (_old == null || linesOfBusiness[index].html == null) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Debe confirmar el contrato antes de continuar...",
        confirmButtonText: "Entendido"
      })
      return
    }
    else if (_old !== _new) {
      const result = await Swal.fire({
        position: "center",
        icon: "warning",
        title: "Ha modificado el contrato ¿Desea continuar sin la modificacion? 2",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar"
      });
      if (!result.isConfirmed) return
    }

    var sfire = Swal.fire({
      title: 'Descargando...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })


    const htmlContent = ReplaceAllTags(linesOfBusiness[index].html, index)
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlContent
    //document.body.appendChild(tempElement)

    try {
      await html2pdf().set(opt).from(tempElement).save()
    } catch (error) {
      console.error('Error al convertir a PDF:', error)
    } finally {
      //   document.body.removeChild(tempElement)
      sfire.close()
    }
  }

  const opt = {
    margin: 10,
    filename: 'document.pdf',
    image: { type: 'jpeg', quality: 0.6 },
    html2canvas: { scale: 1, useCORS: true },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  const handlePageCuotas = (event, newPage) => {
    setPage(newPage);
  };

  // Manejar cambio de filas por página.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const handleConfirmReview = async (index) => {
    var sfire = Swal.fire({
      title: 'Enviando a firmar...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })
    var result = await LobService.SaveHtmlContrat({ ContractLineId: linesOfBusiness[index].id, Html: linesOfBusiness[index].html, layoutId: linesOfBusiness[index].layoutId })

    const UpdTempContrat = [...tempContrat];
    UpdTempContrat[index].html = linesOfBusiness[index].html;
    UpdTempContrat[index].layoutId = linesOfBusiness[index].layoutId;
    setTempContrat(UpdTempContrat);

    sfire.close()

    if (result) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Contrato Guardado Correctamente",
        showConfirmButton: true,
        timer: 2000,
      })
    }
  }

  const showCronologia = async (show) => {

    if (show == false) {
      setOpenM(show)
      return
    }

    const list = await LobService.SearchCronologia(_TAB.interview.id);
    if (list && list.length > 0) {
      setOpenM(show)
      setListCrono(list)
    } else {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Cronologia no encontrada.",
        showConfirmButton: true,
        timer: 2000,
      });
    }


    return;
  }
  const showHA = async () => {
    var hoja = _TAB.interview.content;

    try {
      await html2pdf().set(opt).from(hoja).save()
    } catch (error) {
      console.error('Error al convertir a PDF:', error)
    } finally {
      //   document.body.removeChild(tempElement)
    }


    return;
  }

  const handleConfirm = async () => {
    //dispatch(setTab("5"))
    /*
     DEJAR validar si no esta firmado??
     en ese caso debo esparar la firma de todas formas...
     
    */
    //validaciones de firmas
    const firmados = await LobService.CheckFirmasContrato(formData.identifier, formData.numContrato, _TAB.contractFull.contractId);
    if (firmados) {
      dispatch(setTab("5"))
    } else {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Aun no estan los contratos firmados.",
        showConfirmButton: true,
        timer: 2000,
      });
    }

    // dispatch(setTab("5"))
  }
  const handleContinue = () => {
    dispatch(setTab("5"))
  }

  //paginacion cuota
  const handleChangeRowsCuotas = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Filtrar datos para la página actual.
  const paginatedData = acreedorData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const paginatedCuota = cuotasData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const extraerFecha = (fechaContrato) => {
    let fecha = new Date(fechaContrato);

    let dia = fecha.getDate().toString().trim() || "<span style='background-color:orange'>@dia_entrevista</span>";

    let meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    let mesTexto = meses[fecha.getMonth()].trim() || "<span style='background-color:orange'>@mes_entrevista</span>";

    let año = fecha.getFullYear().toString().trim() || "<span style='background-color:orange'>@año_entrevista</span>";

    return { dia, mesTexto, año };
  }

  const generarTablaCuotas = (cuotas) => {

    if (!Array.isArray(cuotas) || cuotas.length === 0) {
      return "<p style='color: red;'>No hay datos disponibles.</p>";
    }

    let tabla = `
      <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
        <thead>
          <tr>
            <th>N° Cuota</th>
            <th>Fecha</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>`;

    // Función para convertir la fecha al formato "22 de enero de 2025"
    function formatearFecha(fechaISO) {
      if (!fechaISO) return "<span style='background-color:orange'>Fecha no disponible</span>";
      let fecha = new Date(fechaISO);
      let dia = fecha.getDate();
      let mes = fecha.getMonth() + 1; //meses[fecha.getMonth()];
      let año = fecha.getFullYear();
      return `${dia}/${mes.toString().padStart(2, "0")}/${año}`;
    }

    // Recorrer el array y generar las filas de la tabla
    cuotas.forEach(cuota => {
      tabla += `
      <tr>
          <td>${cuota.numeroCuota || "<span style='background-color:orange'>Sin número</span>"}</td>
          <td>${formatearFecha(cuota.fechaCuota)}</td>
          <td>${cuota.monto ? cuota.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
      </tr>`;
    });

    return tabla + ` </tbody> </table> `;
  }
  ///////////////
  const generarTablaAcreedores = (index) => {

    let tabla = `
      <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
        <thead>
          <tr>
            <th>Acreedor</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>`;

    linesOfBusiness[index].contractServices.forEach((service) => {
      service.acreedores.forEach((acreedor) => {
        tabla += `
      <tr>
          <td>${acreedor.demandante}</td>
          <td>${acreedor.monto ? acreedor.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
      </tr>`;
      });
    });

    return tabla + ` </tbody> </table> `;
  }


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const setOpenFirmar = (line, index) => {
    if (!_TAB.Cuotas?.find(x => x.isApproved == true)) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Las cuotas aun no están aprobadas...",
        showConfirmButton: true,
        timer: 2000,
      });
      return
    }

    setShowChooseSignature({ show: true, line, index })
  }

  const label = { inputProps: { 'aria-label': 'Color switch demo' } };
  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Alert className='mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
        <Alert className='mb-4' severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Datos del Cliente</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Identificador"
                  name="identifier"
                  value={formData.identifier}
                  //onChange={handleClientDataChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nombre"
                  name="firstName"
                  value={formData.firstName}
                  //onChange={handleClientDataChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Apellido"
                  name="lastName"
                  value={formData.lastName}
                  //onChange={handleClientDataChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email}
                  //onChange={handleClientDataChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="N° Contrato"
                  name="numContrato"
                  value={formData.numContrato}
                  //onChange={handleClientDataChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  label="Fecha Contrato"
                  value={formData.fechaContrato}
                  //onChange={(date) => handleClientDataChange({ target: { name: 'fechaContrato', value: date } })}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  name="observaciones"
                  multiline
                  rows={4}
                  value={formData.observaciones}
                  onChange={handleClientDataChange}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Hoja de Atencion</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className='p-5'
              component="div"
              dangerouslySetInnerHTML={{ __html: _TAB.interview.content }}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Líneas de Negocio  <LinearProgress hidden={(linesOfBusiness && linesOfBusiness.length > 0) ? true : false} /> </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <LinearProgress hidden={(linesOfBusiness && linesOfBusiness.length > 0) ? true : false} />
            {linesOfBusiness.map((line, index) => (
              <div key={line.idLineOfBusiness} style={{ marginTop: "12px" }}>
                <Grid container spacing={2} style={{ marginBottom: "12px" }}>
                  <Grid item xs={8}>
                    <Typography variant="subtitle1">{line.lineOfBusinessName}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Button className="me-2" style={{ width: '100%' }} variant="contained" color="success"
                      onClick={() => { setOpenFirmar(line, index) }}
                      disabled={bloquearAcciones}>
                      {line.signedManual == true ? "Firmado Manualmente" : (line.signed == true || line.signedXL == true || line.signedGD == true) ? "Firmado Electronicamente" : "Preparar Firma"}
                    </Button>
                    {/*
                    <div className='mb-1 bg-blue'><Button className="me-2" style={{ width: '100%' }} variant="contained" color="success" onClick={() => { ShowPDF(index) }} > Ver Pdf </Button> </div>
                    <div className='mb-1 bg-blue'>{FirmaXmartlab(line, index)}</div>
                    <div className='mb-1 bg-blue'>{FirmaTuFirma(line, index)}</div>
                    */}
                  </Grid>
                </Grid>

                <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Servicio</TableCell>
                        <TableCell>Monto</TableCell>
                        <TableCell>Consentimiento</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {line.contractServices.map(service => (
                        <TableRow key={service.idService}>
                          <TableCell>{service.serviceName}</TableCell>
                          <TableCell>{formatToCLP(service.amount)}</TableCell>
                          <TableCell>
                            <Button className="me-2" variant="contained" color="success" onClick={() => { ShowConsentimiento(service.idService) }} disabled={bloquearAcciones}> Consentimiento </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid container spacing={2} className='mb-2 mt-2'>
                    <Grid item xs={8}>
                      <Typography className='ms-3' variant="subtitle1">Acreedores</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className='mb-2 mt-2'>
                    <Table>
                      <TableBody>
                        {line.contractServices.map(service => (
                          service.acreedores.map((acreedor, index) => (
                            <TableRow key={index}>
                              <TableCell>{acreedor.demandante}</TableCell>
                              <TableCell>{formatToCLP(acreedor.monto)}</TableCell>
                            </TableRow>
                          ))
                        ))}
                      </TableBody>
                    </Table>
                  </Grid>

                </TableContainer>
                <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                  <Grid container spacing={2} className='mb-2 mt-2'>
                    <Table>
                      <TableBody>
                        <TableRow key={index}>
                          <TableCell className='w-25'><Typography className='m-3' variant="subtitle1" >Contrato Seleccionado:</Typography></TableCell>
                          <TableCell className='w-75'>
                            <Autocomplete
                              disablePortal
                              //disabled={bloquearAcciones || contractData.confirmationDate ? true : false}
                              options={templateContratos}
                              defaultValue={templateContratos.find(x => x.id == line.layoutId)?.name || null}
                              onChange={(event, value) => onChangeSelectContract(event, value, index)}
                              renderInput={(params) => <TextField {...params} label="Seleccione Contrato" />}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>

                  <TabContext value={valueTab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={(event, newValue) => setValueTab(newValue)}>
                        <Tab label="Editar Contrato" value="1" hidden={bloquearAcciones} />
                        <Tab label="Ver Contrato" value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Editor
                        disabled={bloquearAcciones}
                        key={index}
                        apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
                        onInit={(evt, editor) => {
                          editorRefs.current[index] = editor;
                        }}
                        initialValue={linesOfBusiness[index].html}
                        onBlur={() => handleEditorBlur(index)}
                        init={{
                          height: 500,
                          menubar: true,
                          plugins: [
                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                          ],
                          toolbar: 'undo redo | blocks | ' +
                            'bold italic forecolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | help',
                        }}
                      />
                    </TabPanel>
                    <TabPanel value="2"> {/* previsualizacion */}
                      <Typography
                        className='p-5'
                        component="div"
                        dangerouslySetInnerHTML={{ __html: ReplaceAllTags(linesOfBusiness[index].html, index) }}
                      />
                    </TabPanel>
                  </TabContext>
                </TableContainer>
                <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
                  <Grid item>
                    <Button variant="contained" color="primary" onClick={() => handleConfirmReview(index)} hidden={bloquearAcciones}> confirmar revision </Button>
                  </Grid>
                </Grid>
              </div>
            ))}
            {/* Agregar formulario para añadir nuevas líneas de negocio */}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Cuotas Pactadas</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {paginatedCuota.map((group, index) => (
              <React.Fragment key={index}>
                {/* Contenedor separado para cada grupo */}

                <Card style={{ marginBottom: '16px' }}>
                  <CardContent>
                    {/* Información general del contrato */}
                    <Typography variant="subtitle1">
                      <strong>Número de Contrato:</strong> {group.numContrato}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Método de Pago:</strong> {group.metodoPagoName}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Número de Cuotas:</strong> {group.numeroCuotas}
                    </Typography>
                    <Typography variant="subtitle1">
                      <strong>Fecha del Primer Pago:</strong> {new Date(group.fechaPrimerPago).toLocaleDateString()}
                    </Typography>

                    {/* Divider para separar la info general de la tabla de cuotas */}
                    <Divider style={{ margin: '16px 0' }} />

                    {/* Mostrar tabla sólo si hay cuotas */}
                    {group.pagoCuotas.length > 0 && (
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                N° de Cuota
                              </TableCell>
                              <TableCell style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                Fecha
                              </TableCell>
                              <TableCell style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                Monto
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {group.pagoCuotas.map((cuota, idx) => (
                              <TableRow key={idx}>
                                <TableCell>Cuota {cuota.numeroCuota}</TableCell>
                                <TableCell>{new Date(cuota.fechaCuota).toLocaleDateString()}</TableCell>
                                <TableCell>{formatToCLP(cuota.monto)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>

                      </TableContainer>
                    )}
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 15]} // Opciones para filas por página.
                      component="div"
                      count={cuotasData.length} // Total de datos.
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handlePageCuotas}
                      onRowsPerPageChange={handleChangeRowsCuotas}
                    />
                  </CardContent>
                </Card>
              </React.Fragment>
            ))}


          </AccordionDetails>
        </Accordion>

        {(linesOfBusiness && linesOfBusiness.length > 0) ?

          <Grid container spacing={2} sx={{ mt: 3 }} justifyContent="flex-end" alignItems="center">
            <Grid item>
              {bloquearAcciones ?
                <Button variant="contained" color="secondary" disabled> Bloqueado </Button> :
                <>{
                  contractData.confirmationDate ?
                    <Button variant="contained" color="success" onClick={handleContinue} > Continuar (Confirmado) </Button> :
                    <Button variant="contained" color="primary" onClick={handleConfirm} > Confirmar Contrato/s </Button>
                }</>
              }
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={showHA} disabled={bloquearAcciones} > hoja de Atención</Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={() => showCronologia(true)} > Cronologia</Button>
            </Grid>
          </Grid>
          : null
        }
      </Paper>


      <Modal
        open={openM}
        onClose={() => showCronologia(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">

        <Box sx={style}>
          <h3>Cronologia</h3>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="right">Información</TableCell>
                  <TableCell align="right">Creador</TableCell>
                  <TableCell align="right">Fecha</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listCrono.map((row) => (
                  <TableRow>
                    <TableCell align="right">{row.message}</TableCell>
                    <TableCell align="right">{row.userCreate}</TableCell>
                    <TableCell align="right">{moment(row.createAt).format("DD-MM-YYYY")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>


      <Modal open={showChooseSignature.show} onClose={() => setShowChooseSignature({ show: false })} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">

        <Box sx={style}>

          <Typography variant="h6">Enviar Contrato a:</Typography>
          <Grid item xs={12} sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
            <TextField
              sx={{ width: "50%" }}
              fullWidth
              label="Correo electrónico"
              variant="outlined"
              name="email"
              type="email"
              value={emailSign}
              onChange={(e) => setEmailSign(e.target.value)}
            />
          </Grid>

          <Typography variant="h6" sx={{ mb: 2 }}>Enviar Via:</Typography>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Modo Firma</TableCell>
                  <TableCell>Enviar/Preparar</TableCell>
                  <TableCell>Revisar/Confirmar</TableCell>
                  <TableCell>Cancelar</TableCell>
                  {/*
                  <TableCell>Descargar</TableCell>
                  */}
                  <TableCell>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* FIRMA GD*/}
                <TableRow hidden={window.HIDE_FIRMA_GD}>
                  <TableCell>FIRMA GD</TableCell>

                  <TableCell>
                    {window.FIRMA_GD ? <>
                      <FormControlLabel
                        control={
                          <Switch
                            {...label}
                            checked={checked}
                            onChange={handleChangeChecked}
                            color="warning"
                          />
                        }
                        label={checked ? 'con Firma' : 'con Codigo'}
                        hidden={showChooseSignature.line?.urlFEGD == null ? false : true}
                        disabled={bloquearAcciones}
                      />
                      <Button onClick={() => handleSign(showChooseSignature.index, "GD", showChooseSignature.line)} hidden={showChooseSignature.line?.urlFEGD == null ? false : true} disabled={bloquearAcciones}><Send color="green" /></Button>
                    </>
                      :
                      <Button><DoDisturb color="danger" /></Button>}
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckhandleSign(showChooseSignature.line.id, showChooseSignature.index, "GD")} hidden={(showChooseSignature.line?.urlFEGD == null || showChooseSignature.line?.urlFEGD == true) ? true : false} disabled={bloquearAcciones}><CloudDownload color="blue" /></Button>
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckCancelSign(showChooseSignature.line?.id, showChooseSignature.index, "GD")} hidden={showChooseSignature.line?.urlFEGD == null ? true : false} disabled={bloquearAcciones}><Trash2 color="red" /></Button>
                  </TableCell>
                  {/*
                  <TableCell>
                    <Button><Download color="green" hidden={showChooseSignature.line?.urlFE == null ? true : false} /></Button>
                  </TableCell>
                  */}
                  <TableCell>
                    {showChooseSignature.line?.urlFEGD == null ?
                      <Alert className='mb-4' severity="info">No Enviado</Alert>
                      :
                      showChooseSignature.line?.signedGD == true ?
                        <Alert className='mb-4' severity="success">Firmado</Alert>
                        :
                        <Alert className='mb-4' severity="warning">Pendiente</Alert>
                    }
                  </TableCell>
                </TableRow>
                {/* TUFIRMA DIGITAL */}
                <TableRow>
                  <TableCell>TU FIRMA (TF)</TableCell>
                  <TableCell>
                    {window.FIRMA_TF ?
                      <Button onClick={() => handleSign(showChooseSignature.index, "TF", showChooseSignature.line)} hidden={showChooseSignature.line?.urlFE == null ? false : true} disabled={bloquearAcciones}><Send color="green" /></Button>
                      :
                      <Button disabled={true}><DoDisturb color="danger" /></Button>}
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckhandleSign(showChooseSignature.line.id, showChooseSignature.index, "TF")} hidden={(showChooseSignature.line?.urlFE == null || showChooseSignature.line?.urlFE == true) ? true : false} disabled={bloquearAcciones}><CloudUpload color="blue" /></Button>
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckCancelSign(showChooseSignature.line?.id, showChooseSignature.index, "TF")} hidden={showChooseSignature.line?.urlFE == null ? true : false} disabled={bloquearAcciones}><Trash2 color="red" /></Button>
                  </TableCell>
                  {/*
                  <TableCell>
                    <Button><Download color="green" hidden={showChooseSignature.line?.urlFE == null ? true : false} /></Button>
                  </TableCell>
                  */}
                  <TableCell>
                    {showChooseSignature.line?.urlFE == null ?
                      <Alert className='mb-4' severity="info">No Enviado</Alert>
                      :
                      showChooseSignature.line?.signed == true ?
                        <Alert className='mb-4' severity="success">Firmado</Alert>
                        :
                        <Alert className='mb-4' severity="warning">Pendiente</Alert>
                    }
                  </TableCell>
                </TableRow>

                {/* xmartlab */}
                <TableRow>
                  <TableCell>XMARTLAB (XL)</TableCell>
                  <TableCell>
                    {window.FIRMA_XL ?
                      <Button onClick={() => handleSign(showChooseSignature.index, "XL", showChooseSignature.line)} hidden={showChooseSignature.line?.urlFEXL == null ? false : true}><Send color="green" /></Button>
                      :
                      <Button><DoDisturb disabled={true} color="red" /></Button>}
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckhandleSign(showChooseSignature.line.id, showChooseSignature.index, "XL")} hidden={showChooseSignature.line?.urlFEXL == null ? true : false}><CloudDownload color="blue" /></Button>
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckCancelSign(showChooseSignature.line?.id, showChooseSignature.index, "XL")} hidden={showChooseSignature.line?.urlFEXL == null ? true : false} disabled={bloquearAcciones}><Trash2 color="red" /></Button>
                  </TableCell>
                  {/*
                  <TableCell>
                    <Button hidden={showChooseSignature.line?.urlFEXL == null ? true : false} disabled={bloquearAcciones}><Download color="green"/></Button>
                  </TableCell>
                  */}
                  <TableCell>
                    {showChooseSignature.line?.urlFEXL == null ?
                      <Alert className='mb-4' severity="info"> No Enviado</Alert>
                      :
                      showChooseSignature.line?.signedXL == true ?
                        <Alert className='mb-4' severity="success">Firmado</Alert>
                        :
                        <Alert className='mb-4' severity="warning">Pendiente</Alert>
                    }
                  </TableCell>
                </TableRow>

                {/* manual */}
                <TableRow>
                  <TableCell>MANUAL</TableCell>
                  <TableCell>
                    <Button onClick={() => handleSign(showChooseSignature.index, "MANUAL", showChooseSignature.line)} hidden={(showChooseSignature.line?.signedManual == null) ? false : true}><CloudDownload color="green" /></Button>
                  </TableCell>
                  <TableCell>
                    {/*
                    <Button onClick={() => UploadSign(showChooseSignature.line.id, showChooseSignature.index)} hidden={showChooseSignature.line?.signedManual == null ? true : false} disabled={bloquearAcciones}><CloudUpload color="blue" /></Button>
                    */}
                    <Button
                      component="label"
                      role={undefined}
                      tabIndex={-1}
                      startIcon={<CloudUpload />}
                      hidden={showChooseSignature.line?.signedManual == null ? true : false}
                      disabled={bloquearAcciones}
                    >
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(event) => UploadSign(showChooseSignature.line.id, showChooseSignature.index, event.target.files)}
                        multiple
                      />
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button onClick={() => CheckCancelSign(showChooseSignature.line?.id, showChooseSignature.index, "MANUAL")} hidden={(showChooseSignature.line?.signedManual == null) ? true : false} disabled={bloquearAcciones}><Trash2 color="red" /></Button>
                  </TableCell>
                  {/*
                  <TableCell>
                    <Button><Download color="green" /></Button>
                  </TableCell>
                  */}
                  <TableCell>
                    {showChooseSignature.line?.signedManual == null ?
                      <Alert className='mb-4' severity="info">No enviado</Alert> :
                      (showChooseSignature.line?.signedManual == true ? <Alert className='mb-4' severity="success">Firmado</Alert> :
                        <Alert className='mb-4' severity="warning">Pendiente</Alert>)
                    }
                  </TableCell>
                </TableRow>

              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>


      {visible && (
        <Fab
          color="primary"
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          <KeyboardArrowUp />
        </Fab>
      )}
    </LocalizationProvider >
  );
};

export default GeneradorForm;